module.exports = __webpack_public_path__ + "img/200px-HK_Princes_Building.a0f9b2d2.jpg";